import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Consulta from "../../components/Consulta";
import useConsulta from "../../components/Consulta/useConsulta";
import { selectUserToken } from "../../features/user";
import paisApi from "../../utility/api/paisApi";
import useQuery from "../../utility/useQuery";
import CadastroPaises from "./CadastroPaises";
import EdicaoPaises from "./EdicaoPaises";
import { checarPermissao, NotAllowed, permissoes, useAthorize } from "../../hooks/useAthorize";

const ConsultaPaises = () => {
  let isAllowed = useAthorize(
    permissoes.localizacaoConsulta,
    permissoes.localizacaoFull
  );

  const token = useSelector(selectUserToken);
  let isEdicaoAllowed = checarPermissao(token, permissoes.localizacaoFull);

  const [isCadastroVisible, setIsCadastroVisible] = useState(false);
  const [isEdicaoVisible, setIsEdicaoVisible] = useState(false);

  const query = useQuery();
  const location = useLocation();
  const navigate = useNavigate();

  let isCadastro = location.pathname === "/pais/cadastro";
  let pagina = parseInt(query.get("page") ?? 0);

  useEffect(() => {
    if (isCadastro) setIsCadastroVisible(true);
  }, [isCadastro]);

  useEffect(() => {
    if (!isCadastroVisible) navigate("/pais/listagem");
  }, [isCadastroVisible, navigate]);

  const filtros = [
    {
      label: "Nome",
      placeholder: "Pesquise pelo nome",
      name: "nome",
    },
  ];

  const colunas = [
    {
      label: "Nome",
      prop: "nome",
      width: "50%",
    },
  ];

  let events = useMemo(() => {
    return {
      onSearch: {
        fetchFunction: paisApi.listarPaises,
      },
      editarLink: (item) => `/pais/listagem?page=${pagina}&paisId=${item.id}`,
      editarEvent: () => setIsEdicaoVisible(true),
    };
  }, [pagina]);

  const consulta = useConsulta(token, events);

  let adicionarButton = (
    <>
      <button
        type="button"
        onClick={() => setIsCadastroVisible(true)}
        className="bg-[#005BBF] text-[#FFF] py-1 px-5 rounded-md hover:bg-[#1E3784]"
      >
        Adicionar
      </button>
      {isCadastroVisible && (
        <CadastroPaises
          setIsVisible={setIsCadastroVisible}
          onFinished={() => consulta.events.onSearch()}
        />
      )}
      {isEdicaoVisible && (
        <EdicaoPaises
          setIsVisible={setIsEdicaoVisible}
          onFinished={() => consulta.events.onSearch()}
        />
      )}
    </>
  );

  if (!isAllowed) return <NotAllowed />;

  return (
    <Consulta
      title="Países"
      adicionarButton={isEdicaoAllowed && adicionarButton}
      colunas={colunas}
      filtros={filtros}
      showOptions={isEdicaoAllowed}
      consulta={consulta}
    />
  );
};

export default ConsultaPaises;
